<dialog #dialog
        class="popin-dialog"
        aria-modal="true" aria-labelledby="titrePopIn">
    <div class="modal-header d-flex justify-content-end">
        <button class="text-info close-alert btn d-inline-flex align-items-center"
                (click)="close(false)">
            <span translate="global.menu.close"></span>
            <ned-icon type="close" class="col-auto"></ned-icon>
        </button>
    </div>
    <div class="mx-5">
        <div class="modal-body">
            <h2 *ngIf="titrePopIn" class="h4 fw-bold" id="titrePopIn">
                {{ titrePopIn }}
            </h2>
            <p class="c-text c-text-home mt-3" role="alert" aria-live="assertive">
                {{ messagePopIn }}
            </p>
        </div>
        <div class="modal-footer pt-5 justify-content-center column-gap-3">
            <button type="button" class="btn btn-outline-info"
                    (click)="close(false)">
                {{ libelleRefuser }}
            </button>
            <button type="button" class="btn btn-info"
                    (click)="close(true)">
                {{ libelleAccepter }}
            </button>
        </div>
    </div>
</dialog>
